<template>
  <div class="Index">
    <Banner v-if="terminal == 'pc'" class="Banner_position"></Banner>
    <MobileBanner v-else></MobileBanner>
    <RecentNew class="anchor" :RecentNewData="RecentNewData"></RecentNew>
    <!-- <MobileRecentNew v-else :RecentNewData="RecentNewData"></MobileRecentNew> -->
    <Society class="anchor" :SocietyData="SocietyData"></Society>
    <Technology2 class="anchor" :TechnologyData="TechnologyData"></Technology2>
    <!-- <Technology v-else :TechnologyData="TechnologyData"></Technology> -->
    <Case class="anchor"></Case>
    <!--  animated fadeInUp -->
    <Knowledge class="anchor"></Knowledge>

    <!-- <swiper></swiper> -->
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import { GetNews } from "@/axios/api.js";
import { dealCode, userinfo } from "@/axios/user.js";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  data() {
    return {
      NewData: null,
      RecentNewData: null,
      TechnologyData: null,
      SocietyData: null,
      knowledgeBase: false,
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    // console.log(this.$route.query.code);
    var code = this.$route.query.code;
    if (code) {
      this.dealCodeFun(code);
    }
    if (this.language == "zh") {
      this.GetNewsFun("SDGs与社会,实时热点,SDGs与科技");
    } else if (this.language == "en") {
      this.GetNewsFun("SDGs and Society,Featured News,Science for SDGs");
    } else {
      this.GetNewsFun("ODD et société,Nouvelles en temps réel,ODD et science");
    }
    bus.$on("anchor", (res) => {});
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 获取窗口滚动条高度
      console.log(scrollTop);
      if (scrollTop > 3300) {
        this.knowledgeBase = true;
      } else {
        this.knowledgeBase = false;
      }
    },
    async dealCodeFun(code) {
      var res = await dealCode(code);
      console.log(res.data.data);
      var param = {
        access_token: res.data.data.access_token,
        token_type: res.data.data.token_type,
      };
      var userInfo = await userinfo(param);
      console.log(userInfo,userInfo.data.data.name);
      if (userInfo.data.code == 200) {
        this.setLoginName(userInfo.data.data.name);
        localStorage.setItem("loginName", userInfo.data.data.name);
        localStorage.setItem("token", userInfo.data.data.token);
      }
    },
    async GetNewsFun(val) {
      //val 查询的属性内容
      var param = {
        channelNames: val,
        showRowCount: 6,
      };
      var res = await GetNews(param);
      this.NewData = res.data.data;
      (this.RecentNewData = this.NewData[0].newsList),
        (this.TechnologyData = this.NewData[1].newsList);
      this.SocietyData = this.NewData[2].newsList;
      setTimeout(() => {
        bus.$emit("showLoadingFun", false);
      }, 1000);
    },
  },
  components: {
    swiper: () => import("../components/Test/swiper.vue"),
    Banner: () => import("../components/Index/Banner/Banner.vue"),
    MobileBanner: () => import("../components/Index/Banner/MobileBanner.vue"),
    RecentNew: () => import("../components/Index/RecentNew/RecentNew.vue"),
    MobileRecentNew: () =>
      import("../components/Index/RecentNew/MobileRecentNew.vue"),
    Society: () => import("../components/Index/Society/Society.vue"),
    Technology: () => import("../components/Index/Technology/Technology.vue"),
    Technology2: () => import("../components/Index/Technology/Technology2.vue"),
    Case: () => import("../components/Index/Case/Case.vue"),
    Sustainable: () =>
      import("../components/Index/Sustainable/Sustainable.vue"),
    Knowledge: () => import("../components/Index/Knowledge/Knowledge.vue"),
  },
  watch: {
    language(val) {
      if (val == "zh") {
        this.GetNewsFun("SDGs与社会,实时热点,SDGs与科技");
      } else if (val == "en") {
        this.GetNewsFun("SDGs and Society,Featured News,Science for SDGs");
      } else {
        this.GetNewsFun(
          "ODD et société,Nouvelles en temps réel,ODD et science"
        );
      }
    },
  },
};
</script>

<style lang="scss">
.Index {
  /* padding-bottom: 300px; */
  .Knowledge_bpx {
    min-height: 704px;
    overflow: hidden;
  }
}

.Banner_position {
}
</style>